import { FC, useRef, MouseEvent } from 'react'
import Draggable from 'react-draggable'
import { Img } from 'react-image'

import './DraggableDiagram.scss'

import { ReactComponent as ExitImage } from '../assets/icons/exit-media-button.svg'
import { ResourceImage } from '../Types'

type Props = {
    diagram: ResourceImage
    path: string
    index: number
    onMouseDown: (diagram: ResourceImage) => void
    onDiagramClose: (e: MouseEvent<HTMLElement>, diagram: ResourceImage) => void
    cssClass: string
}

const DraggableDiagram: FC<Props> = ({ diagram, path, index, onMouseDown, onDiagramClose, cssClass }: Props) => {
    const width = window.outerWidth
    const height = window.outerHeight
    const nodeRef = useRef(null)

    return (
        <Draggable
            nodeRef={nodeRef}
            bounds={{ top: -height, left: -width, right: width, bottom: height }}
            positionOffset={{ x: `${30 + (index * 5)}vw`, y: `-${90 - (index * 3)}vh` }}
            onMouseDown={() => onMouseDown(diagram)}
        >
            <div
                ref={nodeRef}
                className={cssClass}
            >
                <Img
                    alt=''
                    key={diagram.filename}
                    src={path + diagram.filename}
                    container={(children) => (
                        <div className='diagram img-fluid'>
                            <div className="exitButton" onClick={(e: MouseEvent<HTMLElement>) => onDiagramClose(e, diagram)}>
                                <ExitImage />
                            </div>
                            {children}
                        </div>
                    )}
                />
            </div>
        </Draggable>
    )
}
export default DraggableDiagram